import React from "react";
import { useDrop, DragPreviewImage, useDrag } from "react-dnd";

import Color from "../Color";
import ItemTypes from "../ItemTypes";
import arrayIdFinder from "../helpers/arrayIdFinder";

import Text from "./Text";
import EmployeeIcons from "./EmployeeIcons";

const WIDTH = 250;
const HEIGHT = 100;

function EmployeeCard({
  id,
  x,
  y,
  entityName,
  addEmployees,
  lineManager,
  toggleCollapse,
  isCollapsed,
  startEntityDragging,
  stopEntityDragging,
  parentId,
  isAncestor,
  onEntityDrop
}) {
  // const [{ isOver, canDrop }, drop] = useDrop({
  //   accept: ItemTypes.EMPLOYEE,
  //   drop: ({ selected, idDragged }) => {
  //     if (lineManager) return;
  //     addEmployees(id, [idDragged]);
  //   },
  //   canDrop: () => !lineManager,
  //   collect: mon => ({
  //     isOver: !!mon.isOver(),
  //     canDrop: !!mon.canDrop()
  //   })
  // });

  // const lineManagerDetails = arrayIdFinder(employeeDetails, lineManager);

  // return (
  //   <g
  //     ref={drop}
  //     transform={`translate(${x},${y})`}
  //     filter={isOver && canDrop ? "url('#colorMeHueRotate')" : undefined}
  //   >
  //     <rect
  //       rx={10}
  //       x={0}
  //       y={0}
  //       width={WIDTH}
  //       height={HEIGHT}
  //       fill="url(#gradient)"
  //     />

  //     <g onClick={toggleCollapse} className="clickable">
  //       <circle
  //         r={18}
  //         cx={WIDTH * 0.5}
  //         cy={HEIGHT - 6}
  //         fill={Color.gradientMid}
  //         stroke={Color.initial}
  //         strokeWidth={1}
  //       />
  //       <image
  //         x={WIDTH * 0.5 - 10}
  //         y={HEIGHT - 6 - 10}
  //         width="20"
  //         height="20"
  //         href={`/icons/${isCollapsed ? "up" : "down"}-chevron.svg`}
  //       />
  //     </g>

  //     {!lineManager && (
  //       <g>
  //         <Text
  //           x={WIDTH * 0.5}
  //           y={HEIGHT * 0.35}
  //           fontSize={20}
  //           fill={Color.initial}
  //           textAnchor="middle"
  //           width={WIDTH * 0.95}
  //           text="Drag line manager for"
  //         />
  //         <Text
  //           x={WIDTH * 0.5}
  //           y={HEIGHT * 0.35 + 30}
  //           fontSize={20}
  //           fill={Color.initial}
  //           textAnchor="middle"
  //           width={WIDTH * 0.95}
  //           text={`"${entityName}" here`}
  //         />
  //       </g>
  //     )}

  //     {lineManager && (
  //       <g>
  //         <g>
  //           <pattern
  //             // id={`profile_pic_pattern_${lineManagerDetails.id}`}
  //             height="100%"
  //             width="100%"
  //             patternContentUnits="objectBoundingBox"
  //           >
  //             <image
  //               xlinkHref={`/users/${
  //                 "default_user.png"}`} //
  //               preserveAspectRatio="none"
  //               width="1"
  //               height="1"
  //             />
  //           </pattern>
  //           <circle
  //             cx={WIDTH * 0.125}
  //             cy={HEIGHT * 0.4}
  //             r={WIDTH * 0.1}
  //             fill={`url(#profile_pic_pattern_${lineManagerDetails.id})`}
  //           />
  //         </g>
  //         <Text
  //           x={WIDTH * 0.6}
  //           y={HEIGHT * 0.35}
  //           fontSize={20}
  //           fill={Color.initial}
  //           textAnchor="middle"
  //           width={WIDTH * 0.75}
  //           text={lineManagerDetails.name}
  //         />
  //         <Text
  //           x={WIDTH * 0.6}
  //           y={HEIGHT * 0.35 + 30}
  //           fontSize={20}
  //           fill={Color.initial}
  //           textAnchor="middle"
  //           width={WIDTH * 0.75}
  //           text={lineManagerDetails.position}
  //         />
  //       </g>
  //     )}
  //   </g>
  // );

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: [ItemTypes.EMPLOYEE, ItemTypes.ENTITY],
    drop: ({ type, entityId, selected, idDragged }) => {
      if (type === ItemTypes.ENTITY) {
        onEntityDrop(id, entityId);
        return;
      }
      const selected_arr = Object.keys(selected).filter(
        k => selected[k] && k !== idDragged
      );
      addEmployees(id, [idDragged, ...selected_arr]);
    },
    canDrop: ({ type, entityId, entityParentId }) => {
      if (
        type === ItemTypes.ENTITY &&
        (entityId === id || entityParentId === id || isAncestor(id, entityId))
      )
        return false;
      return true;
    },
    collect: mon => ({
      isOver: !!mon.isOver(),
      canDrop: !!mon.canDrop()
    })
  });

  const [{ isDragging }, drag, preview] = useDrag({
    item: { type: ItemTypes.ENTITY, entityId: id, entityParentId: parentId },
    collect: mon => ({
      isDragging: !!mon.isDragging()
    }),
    begin: startEntityDragging,
    end: stopEntityDragging
  });

  return (
    <g
      ref={drop}
      transform={`translate(${x},${y})`}
      filter={
        isOver && canDrop
          ? "url('#colorMeHueRotate')"
          : isDragging
          ? "url('#colorMeSaturate')"
          : undefined
      }
    >
      <DragPreviewImage connect={preview} src={"/dragPreview.png"} />

      <rect rx={10} width={WIDTH} height={HEIGHT} fill={"url(#gradient)"} />

      <Text
        width={WIDTH * 0.9}
        x={WIDTH * 0.5}
        y={HEIGHT * 0.40}
        textAnchor="middle"
        fontSize={20}
        fontWeight="400"
        fill={Color.initial}
        text={entityName}
      />

      <g onClick={toggleCollapse} className="clickable">
        <circle
          r={18}
          cx={WIDTH * 0.5}
          cy={HEIGHT - 6}
          fill={Color.gradientMid}
          stroke={Color.initial}
          strokeWidth={1}
        />
        <image
          x={WIDTH * 0.5 - 10}
          y={HEIGHT - 6 - 10}
          width="20"
          height="20"
          href={`/orgchart/icons/${isCollapsed ? "up" : "down"}-chevron.svg`}
        />
      </g>

      <g>
          <Text
            x={WIDTH * 0.5}
            fill={Color.initial}
            textAnchor="middle"
            y={HEIGHT * 0.65}
            width={WIDTH * 0.9}
            fontSize={15}
            text={lineManager}
          />
        </g>

      <g
        className="clickable"
        transform={`translate(${WIDTH * 0.15},${HEIGHT - 12})`}
      >
      </g>
    </g>
  );
}

export default EmployeeCard;
